require('./graphicOverlayController');

"use strict";

angular.module('app.shared.graphicOverlay.graphicOverlayDirective', [
  'app.shared.graphicOverlay.graphicOverlayController'
])
    .directive('graphicOverlay', [
      function () {
        return {
          restrict: 'E',
          templateUrl: 'components/shared/graphicOverlay/graphicOverlayView.html',
          controller: 'app.shared.graphicOverlay.graphicOverlayController',
          scope: {
            game: '=',
            layout: '<',
            save: '&?'
          }
        }
      }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/graphicOverlay/graphicOverlayDirective.js